import { render, staticRenderFns } from "./peopleCount.vue?vue&type=template&id=006bc189&scoped=true&"
import script from "./peopleCount.vue?vue&type=script&lang=js&"
export * from "./peopleCount.vue?vue&type=script&lang=js&"
import style0 from "./peopleCount.vue?vue&type=style&index=0&id=006bc189&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006bc189",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VMenu,VTextField})
